// getRecommendations.js

const calculateProductScore = (
  product,
  selectedPreferences,
  selectedFeatures
) => {
  let score = 0;

  selectedPreferences.forEach((selectedPref) => {
    if (product.preferences.includes(selectedPref)) {
      score++;
    }
  });

  selectedFeatures.forEach((selectedFeature) => {
    if (product.features.includes(selectedFeature)) {
      score++;
    }
  });

  return score;
};

const getRecommendations = (
  formData = {
    selectedPreferences: [],
    selectedFeatures: [],
    selectedRecommendationType: '',
  },
  products = []
) => {
  const { selectedPreferences, selectedFeatures, selectedRecommendationType } =
    formData;

  if (!products || products.length === 0) {
    return [];
  }

  if (selectedPreferences.length === 0 && selectedFeatures.length === 0) {
    return [];
  }

  const productsWithScore = products.map((product) => ({
    ...product,
    score: calculateProductScore(
      product,
      selectedPreferences,
      selectedFeatures
    ),
  }));

  const validProducts = productsWithScore.filter(
    (product) => product.score > 0
  );

  if (validProducts.length === 0) {
    return [];
  }

  validProducts.sort((a, b) => b.score - a.score);

  if (selectedRecommendationType === 'SingleProduct') {
    const maxScore = validProducts[0].score;

    const topProducts = validProducts.filter(
      (product) => product.score === maxScore
    );

    return [topProducts[topProducts.length - 1]];
  } else if (selectedRecommendationType === 'MultipleProducts') {
    return validProducts;
  }

  return [];
};

const recommendationService = { getRecommendations };

export default recommendationService;
